import { DEFAULT_PROMOPIXEL_DOMAINS } from "../common/ds24_root_url";
import { ds24cart_element_id } from "./ds24cart_element_id";
import { ds24cart_jsonp_args } from "./ds24cart_jsonp_args";
import { ds24cart_show_exec } from "./ds24cart_show";
import { ds24cart_wait_start, ds24cart_wait_stop } from "./ds24cart_wait";

import { ds24cart_checkout_exec } from "./ds24cart_checkout";
import { ds24cart_init_info_bar } from "./ds24cart_init_info_bar";
import { ds24cart_maybe_show_msg } from "./ds24cart_maybe_show_msg";
import { ds24_retrieve } from "../common/ds24_retrieve";
import { ds24cart_activate_buttons } from "./ds24cart_activate_buttons";
import { ds24cart_id } from "./ds24cart_id";
import { request } from "../browser/request";
import { setHtml } from "../browser/setHtml";
import { ds24_checkout_url } from "../common/ds24_checkout_url";

export interface ResponseJsonPData {
    javascript: string;
}

export function ds24cart_loader()
{
    // ALL urls must end with / (except css)


    const allowedDomainList = DEFAULT_PROMOPIXEL_DOMAINS;

    const basePath = '/add/';

    const addUrl = ds24_checkout_url() + '/cart/add/'

    const cartPath = '/cart/';

    const checkoutPath = '/checkout/';

    const css_file = window.DS24_THEME
                 ? window.DS24_THEME
                 : 'cart';

    import(/* webpackChunkName: "[request]" */`../../../assets/css/${css_file}.css`);

    document.querySelectorAll('a').forEach((a: HTMLAnchorElement) => {
            let linkUrl: URL|null = null;
            const href = a.getAttribute( 'href' );
            if (!href) {
                return;
            }

            const href_lower = href.toLowerCase();

            try {
                linkUrl = new URL(href_lower);
                // eslint-disable-next-line no-empty
            } catch(e) {}

            if (!linkUrl) {
                return;
            }

            const isAllowedOrigin = allowedDomainList.indexOf(linkUrl.origin) >= 0;

            if (!isAllowedOrigin) {
                return;
            }


            const isBaseUrl = linkUrl.pathname.substring(0, basePath.length) === basePath;

            if (isBaseUrl) {

                let product_id = linkUrl.pathname.substring(basePath.length);

                let pos = product_id.indexOf( '?' );
                if (pos>=0) {
                    product_id = product_id.substring( 0, pos );
                }
                pos = product_id.indexOf( '/' );
                if (pos>=0) {
                    product_id = product_id.substring( 0, pos );
                }

                const new_url = addUrl + product_id;
                a.setAttribute('href', new_url );
                a.setAttribute('app-product-id',product_id );

                a.addEventListener('click', function(e) {

                    e.preventDefault();
                    ds24cart_wait_start();

                    const quantity=1;
                    const url = a.getAttribute('href') + '?' + ds24cart_jsonp_args() + '&quantity='+quantity;

                    request<ResponseJsonPData>({
                        url: url,
                        dataType: 'jsonp',
                        success: ds24cart_callback_add,
                    });
                    return false;
                });

                return;
            }

            let path = linkUrl.pathname;
            if (path.slice(-1) !== '/') {
                path += '/';
            }


            const isCartUrl = path === cartPath;
            if (isCartUrl) {

                const _button_id = ds24cart_element_id( a );

                if (!window.DS24_TOOLTIP_SHOWN_BY_CLICK) {
                    a.addEventListener('mouseenter', function() {
                        ds24cart_show_exec( _button_id );
                    });
                }

                a.addEventListener('click', function(e) {
                    e.preventDefault();
                    window.DS24_TOOLTIP_SHOWN_BY_CLICK = true;
                    ds24cart_show_exec( _button_id );
                    return false;
                });
            }

            const isCheckout = path === checkoutPath;
            if (isCheckout) {
                a.addEventListener('click', function(e) {
                    e.preventDefault();
                    ds24cart_checkout_exec();
                    return false;
                });
            }



        }
    );

    ds24cart_init_info_bar();

    request<ResponseJsonPData>({
        method: 'GET',
        dataType: 'jsonp',
        url: ds24_checkout_url() + '/cart/onload/' + '?' + ds24cart_jsonp_args(),
        success: ds24cart_callback_javascript,
    });

    if (window.DS24_INFO_STICKY) {
        request<ResponseJsonPData>({
            method: 'GET',
            dataType: 'jsonp',
            url: ds24_checkout_url() + '/cart/show_infobar_buttons/' + '?' + ds24cart_jsonp_args(),
            success: ds24cart_callback_add,
        });
    }
}

export function ds24cart_callback_javascript( result: ResponseJsonPData )
{
    if (typeof result[ 'javascript' ] != 'undefined')
    {
        alert(result[ 'javascript' ]);

        const F=new Function (result[ 'javascript' ]);

        F();
    }
}


export function ds24cart_callback_add( result: any )
{
    ds24cart_maybe_show_msg( result );

    const cart_id = ds24_retrieve( result, 'cart_id' );
    const html    = ds24_retrieve( result, 'html' );

    if (!cart_id || !html) {
        ds24cart_wait_stop();
        return;
    }

    ds24cart_init_info_bar();

    ds24cart_id( cart_id );

    const container = document.getElementById('app_cart_added_container');
    setHtml(container, html);


    ds24cart_activate_buttons( '#app_cart_added_container' );

    ds24cart_wait_stop();


    container?.classList?.add('open');

}
